import { useLanguage } from './language-context';

// en/bn switch (FR-C18, DR-16) — the customer design's top-bar language button
// (Others.dc.html L139): one pill that names the OTHER language ("বাং" while English
// shows, "EN" while Bangla shows) and flips to it. Persists via the language context;
// every screen re-renders with the new dictionary. Duplicated per surface (CB-10).
export function LanguageToggle() {
  const { lang, setLang, t } = useLanguage();
  const next = lang === 'en' ? 'bn' : 'en';
  return (
    <button
      type="button"
      className="lang-btn"
      lang={next}
      aria-label={`${t('user.shell.lang.switch')}: ${t(next === 'bn' ? 'lang.bn' : 'lang.en')}`}
      onClick={() => setLang(next)}
    >
      {t(next === 'bn' ? 'lang.bn_short' : 'lang.en_short')}
    </button>
  );
}
